import spawn from './spawn';

const services = {
  spawn,
};

export default services;
